export default "__VITE_ASSET__wqjqkzvj__"